import type { FaireProductEntity } from "../../entity_types/product";

export const p_aa2agphu76: FaireProductEntity = {
  token: "p_aa2agphu76",
  type: "product",
  name: "Black Bandana Fringe Crossbody",
  brandToken: "b_5m4wqw135i",
  brandName: "Panache Apparel Co.",
  imageUrl: "https://cdn.faire.com/fastly/407ecddc0ef85bb25002d202ace985881423b3f43552cfc16fc5a09eeda9baa5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/adcd0a6a362d371750f2aff237dabed76fd74dbb0744a137a309efa696341463.jpeg",
    "https://cdn.faire.com/fastly/d852da349f88475531e3c18d2a6ff7557d365bd9447f61eb6d7cbf39a8639f7f.jpeg"
  ],
  priceDollars: 37.95,
  description: "A black bandana fringe crossbody featuring a classic paisley print, designed with a long crossbody strap and suede leather fringe detailing for a stylish western-inspired look. Roomy interior is perfect for carrying daily essentials while adding a statement touch to any outfit.\n\n14\" W x 10\" H\n\n100% Cotton\n\nMin. Qty: 2",
  tags: [],
  msrpDollars: 94.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:05:43.359Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
